import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import {
  ProtocolCreation,
  DashboardProtocol,
  Login,
  Dashboard,
  ProtocolSearch,
} from "./containers";
import DashboardContext from "./context/DashboardContext";

const NotFound = () => <h1>Página não encontrada.</h1>;

const Private = ({ children }) => {
  const { isAuthenticated } = useContext(DashboardContext);

  return isAuthenticated ? children : <Redirect to="/login" />;
};

const RouterContainer = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/protocolcreation">
          <ProtocolCreation />
        </Route>
        <Route exact path="/protocolDetails/:protocolId">
          <DashboardProtocol />
        </Route>
        <Route exact path="/protocolsearch">
          <ProtocolSearch />
        </Route>
        <Private>
          <Switch>
            <Route exact path="/dashboard">
              <Dashboard />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Private>
      </Switch>
    </Router>
  );
};

export default RouterContainer;
